import fertilityInjectionImage from '../../../assets/website/images/Fertility-Injection-icon.png';
import selfCareImage from '../../../assets/website/images/postpartum-self-care-icon.png';
import childCareImage from '../../../assets/website/images/child-care-icon.png';
import { GetServices } from '../services/cms.services';
import { useEffect, useState } from 'react';

export default function Services() {
  const [services, setServices] = useState([]);

  const serviceContent = [
    {
      title: "fertility injection concierge",
      subCategories: [
        "IVF injection services",
        "Egg-freezing injection services"
      ]
    },
    {
      title: "self-care",
      subTitle: "(pregnancy, postpartum + everyday)",
      subCategories: [
        "At Home massage 'The Recovery'",
        "Doula",
        "Night Nanny"
      ]
    },
    {
      title: "child care",
      subCategories: [
        "Babysitter",
        "Nanny",
        "Specialty nanny (summer, event, travel, special support)"
      ]
    },
    {
      title: "senior care",
      subCategories: [
        "Companionship",
        "At home support"
      ]
    }
  ];

  useEffect(() => {
    GetServices().then((response) => {
      if (response.success) {
        setServices(response.data);
      } else {
        console.error("error", response);
      }
    }).catch((err) => {
      console.error("err", err);
    });
  }, [])
  return (
    <section className="care-meets section-padding">
      <div className="container-fluid">

        <div className="heading-content">
          <div className='row row-gap-3 justify-content-between align-items-center'>
            <div className='col-lg-5'>
              <h2 className="h2">babe. shows up at <br /> <span className="ed_los_alamos">every</span> stage.</h2>
            </div>
            <div className='col-lg-5'>
              <p className="ink"> for fertility, pregnancy, postpartum, self care + family life, we’re here with support for every stage. one app puts expert support in your pocket, 24/7.</p>
            </div>
          </div>
        </div>
        {/* <div className="row row-gap-4">
          {
            services.map((item, index) => {
              return (
                <div className="col-xl-3 col-md-6 d-flex flex-column" key={index}>
                  <div className="care-box">
                    <div className="icon-box">
                  
                      <img className='w-100' src={item?.image} alt={item?.title} />
                    </div>
                    <h4 className="fs-5 ink mb-3">{item?.title}</h4>
                    {
                      item?.subCategories?.length ?
                        <ul className='custom-bullets'>
                          {
                            item?.subCategories?.map((subItem, subIndex) => {
                              return (<li key={subIndex}>{subItem?.title}</li>)
                            })
                          }
                        </ul>
                        : null
                    }
                  </div>
                </div>
              )
            })
          }
        </div> */}

        <div className="row row-gap-4">
          {serviceContent.map((item, index) => (
            <div className="col-xl-3 col-md-6 d-flex flex-column" key={index}>
              <div className="care-box">
                <div className="icon-box">
                  <img
                    className="w-100"
                    src={services?.[index]?.image}
                    alt={item.title}
                  />
                </div>

                <h4 className="fs-5 ink mb-3">
                  {item.title}
                  {item.subTitle && (
                    <span className="d-block small">
                      {item.subTitle}
                    </span>
                  )}
                </h4>

                <ul className="custom-bullets">
                  {item.subCategories.map((subItem, subIndex) => (
                    <li key={subIndex}>{subItem}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
